<script>
    import { LottiePlayer } from '@lottiefiles/svelte-lottie-player';
</script>

<!--https://lottiefiles.com/user/69888-->
<div class="spinner">
    <LottiePlayer src="https://assets2.lottiefiles.com/packages/lf20_VDNxBo.json" background="transparent" renderer="svg" speed={1} direction={1} width={300} height={300} autoplay={true} loop={false} controls={false} controlsLayout={[]} />
</div>
<!--alternative -->
<!--https://lottiefiles.com/mervinin-->
<!-- <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_a5nWM9.json" background="#38c172" speed="1" direction="-1" style="width: 300px; height: 300px;" autoplay></lottie-player> -->


<!--alternative -->
<!--https://lottiefiles.com/sanil297-->
<!-- <lottie-player src="https://assets5.lottiefiles.com/packages/lf20_xhyszish.json" background="transparent" speed="1" direction="-1" style="width: 300px; height: 300px;" autoplay></lottie-player> -->


<!--alternative, has exact match for lock-->
<!--https://lottiefiles.com/user38902-->
<!-- <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_osxmdszi.json"  background="transparent"  speed="1"  style="width: 300px; height: 300px;"  loop controls autoplay></lottie-player> -->